module.exports = __webpack_public_path__ + "img/jcnr3.e586b62c.png";